import { Box, Typography } from "@mui/material"
import EnvelopeAnimation from "../components/EnvelopeAnimation"
import { ScrollButton } from "../components/ScrollButton";
import { useEffect, useRef } from "react";

const LetterSection = () => {

  const handleScrollUp = (e) => {
    const currentScroll = window.scrollY;
    const viewPortHeight = window.innerHeight;
    window.scrollTo({
      top: currentScroll - (viewPortHeight / 2),
      behavior: "smooth",
    });
  }


  return (
    <Box
      sx={{
        zIndex: 1,
        position: "relative",
        p: 4,
        textAlign: "center",
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        scrollSnapAlign: 'start',
      }}
    >
      <ScrollButton onClick={(e) => handleScrollUp(e)} text="เลื่อนกลับขึ้นไป" scrollUp />

      <Typography
        align="center"
        variant="h4"
        color="secondary"
        sx={{ fontWeight: 'bold' }}
      >
        เค้ามีอะไรจะบอกก 💌
      </Typography>

      <Box sx={{ mt: 12, pt: 8, justifyContent: 'center', display: 'flex' }}>
        <EnvelopeAnimation message={
          <div>
            ขอให้วันวาเลนไทน์นี้ บี๋มีความสุขมากๆ มีแต่เรื่องดีๆเข้ามา สมหวังทุกอย่างนะ <br /><br />
            รักบี๋มากๆ 💖<br />
            I'm proud of you 🌈
          </div>
        } />
      </Box>

    </Box>
  )
}

export default LetterSection